<template>
	<div class="m-related-news" v-if="show">
		<h4 class="m-bt">
			<span class="u-tt">推荐阅读</span>
		</h4>
		<news-item v-for="item of relatedNews" :key="item.id" :item="item"></news-item>
	</div>
</template>

<script>
import imgMixin from 'mixins/image'
import NewsItem from './news_stream/news-item'
export default {
	mixins: [imgMixin],
	props: ['list'],
	components: {
		NewsItem
	},
	computed: {
		show() {
			if(Jt.array.isEmpty(this.list)) {
				return false;
			}
			return true;
		},
		relatedNews() {
			const relatedNews = this.list || [];
			for(let i = 0, len = relatedNews.length; i < len; i++) {
				relatedNews[i].view_type = 'normal';
				relatedNews[i].id = relatedNews[i].articleId;
				relatedNews[i].news_timestamp = relatedNews[i].date;
				// relatedNews[i].image = [];
				// if(relatedNews[i].img_url) {
				// 	relatedNews[i].image.push(relatedNews[i].img_url);
				// }
			}
			return relatedNews;
		}
	}
}
</script>


// WEBPACK FOOTER //
// news-related.vue?c66a0684